// extracted by mini-css-extract-plugin
module.exports = {"section":"DashboardMetricSection_section__3oLI4","value":"DashboardMetricSection_value__1GNzP","description":"DashboardMetricSection_description__1AGRw"};